import React from "react";

function Colors_2016() {
  return (
    <div>
      <h1>Colors_2016 Component</h1>
      <p>This is the Colors 2016 tutorial page content.</p>
    </div>
  );
}

export default Colors_2016;
